import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexColumn, FlexRow } from '../components/atoms/layout/Flex'
import Label from '../components/atoms/display/Label'
import DashboardCard from '../components/molecules/display/DashboardCard'
import {
  AccountsIcon,
  AggregationIcon,
  BillingIcon,
  ContractIcon,
  DeliveredIcon,
  IdentificationIcon,
  MessageIcon,
  PaymentIcon,
  PendingApprovalDocumentIcon,
  ProjectIcon,
  ReceivedDocumentIcon,
  VisitorRegistrationIcon,
} from '../components/atoms/display/Icons'
import useRouter from '../hooks/useRouter'
import usePage from '../hooks/usePage'
import { DashboardActions } from '../store/dashboard'
import { DashboardSelectors } from '../store/dashboard/selectors'
import { CompanySelectors } from '../store/company/selectors'
import useProcessing from '../hooks/useProcessing'
import FactoringBanner from '../components/organisms/advertisement/factoring_banner'
import { SessionSelectors } from '../store/session/selectors'

export default function DashboardPage() {
  const {
    pendingTransactions,
    receivedTransactions,
    deliveredTransactions,
    messages,
    paymentBillings,
    activeTransactions,
    billingTransactions,
    aggregation,
    adminRepresentatives,
    visitorRegistration,
  } = useRouter()
  const user = useSelector(SessionSelectors.user)
  const { changeTitle } = usePage()
  const dispatch = useDispatch()
  const data = useSelector(DashboardSelectors.data)
  const isRS = useSelector(CompanySelectors.isRS)
  const { processing, startProcess } = useProcessing(DashboardActions.fetchDashboard.typePrefix)
  const representatives = useSelector(CompanySelectors.representatives)

  useEffect(() => {
    changeTitle('ダッシュボード')
  }, [changeTitle])
  useEffect(() => {
    startProcess()
    if (user) {
      dispatch(DashboardActions.fetchDashboard({ silent: true, isStaff: user.isStaff }))
    }
  }, [dispatch, startProcess, user])
  return (
    <FlexColumn>
      <FlexColumn>
        <Label text="取引" variant="subtitle" />
        <FlexRow wrap>
          <DashboardCard
            label="あなたの承認待ち"
            icon={<PendingApprovalDocumentIcon size={64} />}
            count={data.documents.count.unapproved}
            loading={processing}
            onClick={() => pendingTransactions()}
          />
          <DashboardCard
            label="社内確認待ち"
            icon={<ReceivedDocumentIcon size={64} />}
            count={data.documents.count.submitted}
            loading={processing}
            onClick={() => receivedTransactions()}
          />
          <DashboardCard
            label="進行中の取引"
            icon={<ContractIcon size={64} />}
            count={0}
            onClick={() => activeTransactions()}
          />
          {isRS ? (
            <DashboardCard
              label="完納"
              icon={<DeliveredIcon size={64} />}
              count={0}
              onClick={() => deliveredTransactions()}
            />
          ) : (
            <DashboardCard
              label="請求の確認"
              icon={<BillingIcon size={64} />}
              count={0}
              onClick={() => billingTransactions()}
            />
          )}
          <DashboardCard label="支払い" icon={<PaymentIcon size={64} />} count={0} onClick={() => paymentBillings()} />
        </FlexRow>
      </FlexColumn>
      <FlexColumn>
        <Label text="通知" variant="subtitle" />
        <FlexRow wrap>
          <DashboardCard
            label="メッセージ"
            icon={<MessageIcon size={64} />}
            count={data.messages.count.unread}
            hasNew={data.messages.hasToMentioned}
            loading={processing}
            onClick={() => messages()}
          />
        </FlexRow>
      </FlexColumn>
      {user?.isStaff && (
        <FlexColumn>
          <Label text="管理" variant="subtitle" />
          <FlexRow wrap>
            <DashboardCard
              label="本人確認"
              icon={<IdentificationIcon size={64} />}
              count={
                representatives.filter(
                  (representative) =>
                    representative.submittedAt !== null &&
                    representative.acceptedAt === null &&
                    representative.rejectedAt === null
                ).length
              }
              loading={processing}
              onClick={() => adminRepresentatives()}
            />
          </FlexRow>
        </FlexColumn>
      )}

      <FlexColumn>
        <Label text="その他" variant="subtitle" />
        <FlexRow wrap>
          <DashboardCard label="集計" icon={<AggregationIcon size={64} />} count={0} onClick={() => aggregation()} />
          <DashboardCard
            label="顧客管理"
            icon={<AccountsIcon size={64} />}
            count={0}
            href={`${process.env.REACT_APP_SFA_BASE_URL ?? ''}/customers`}
          />
          <DashboardCard
            label="案件管理"
            icon={<ProjectIcon size={64} />}
            count={0}
            href={`${process.env.REACT_APP_SFA_BASE_URL ?? ''}/projects`}
          />
          <DashboardCard
            label="新規入場者調査票"
            icon={<VisitorRegistrationIcon size={64} />}
            count={0}
            onClick={() => visitorRegistration()}
          />
        </FlexRow>
      </FlexColumn>
      <FactoringBanner />
    </FlexColumn>
  )
}
